import React from "react";

const LogoutPage = () => {
  return (
    <>
      <div>Logout</div>
    </>
  );
};

export default LogoutPage;
